import LocationRow from '../LocationRow/LocationRow'
import { LocationRowData } from '../useLocationsTable'
import { Td } from '../../styled-components'

const COLUMN_COUNT = 3

interface LocationsTableBodyProps {
  rows: LocationRowData[]
  editLabel: string
  deleteLabel: string
  emptyText: string
}

const LocationsTableBody = ({ rows, editLabel, deleteLabel, emptyText }: LocationsTableBodyProps) => {
  if (rows.length === 0) {
    return (
      <tr>
        <Td colSpan={COLUMN_COUNT}>{emptyText}</Td>
      </tr>
    )
  }

  return (
    <>
      {rows.map(row => (
        <LocationRow key={row.id} row={row} editLabel={editLabel} deleteLabel={deleteLabel} />
      ))}
    </>
  )
}

export default LocationsTableBody
